// Application routes configuration
export const ROUTES = {
  // Auth
  login: '/login',
  register: '/register',
  
  // Dashboard
  dashboard: '/app',
  
  // Notepad
  notepad: '/app/notepad',
  
  // Sales
  sales: '/app/sales',
  salesQuotations: '/app/sales/quotations',
  salesTaxInvoices: '/app/sales/tax-invoices',
  salesMilestones: '/app/sales/milestones',
  salesProformaInvoices: '/app/sales/proforma-invoices',
  salesProformaCreate: '/app/sales/proforma/create',
  salesProformaEdit: '/app/sales/proforma/:id/edit',
  salesContacts: '/app/sales/contacts',
  salesContactDetail: '/app/sales/contacts/:id',
  salesScraper: '/app/sales/lead-scraper',
  contacts: '/app/sales/contacts',
  contactDetail: '/app/sales/contacts/:id',
  
  // Sales Operations
  svcClientsProspects: '/app/clients-prospects',
  
  // Settings
  settings: '/app/settings',
  settingsMasterDataQuotation: '/app/settings/master-data/quotation',
  
  // Master Data Settings
  settingsMasterDataProductsServices: '/app/settings/master-data/products-services',
  settingsMasterDataHsnSac: '/app/settings/master-data/hsn-sac',
  settingsMasterDataTaxes: '/app/settings/master-data/taxes',
  settingsMasterDataUnits: '/app/settings/master-data/units',
  settingsMasterDataPaymentTerms: '/app/settings/master-data/payment-terms',
  settingsMasterDataAssumptionsExclusions: '/app/settings/master-data/assumptions-exclusions',
  settingsMasterDataTermsConditions: '/app/settings/master-data/terms-conditions',
  settingsMasterDataBankDetails: '/app/settings/master-data/bank-details',
  settingsMasterDataDeclarations: '/app/settings/master-data/declarations',
  settingsMasterDataQuotationDefaults: '/app/settings/master-data/quotation-defaults',
  settingsMasterDataDisplaySettings: '/app/settings/master-data/display-settings',
  settingsMasterDataDocumentNumbering: '/app/settings/master-data/document-numbering',
  
  // Spaces
  spaces: '/spaces',

  // ── HR / People section ──────────────────────────────────────────────
  hr: '/app/people',
  hrDashboard: '/app/hr/dashboard',
  recruitment: '/app/hr/recruitment',
  offerLetters: '/app/hr/offer-letters',
  hrOnboarding: '/app/hr/onboarding',
  hrOnboardingDocument: '/app/hr/onboarding/:candidateId/documents/:docCode',
  hrDocumentTemplates: '/app/settings/hr/templates',
  attendance: '/app/attendance',
  biometricAdmin: '/app/attendance/biometric',
  leaves: '/app/leaves',
  performance: '/app/hr/performance',
  incentives: '/app/hr/incentives',
  hrPerformanceSettings: '/app/settings/hr/performance',
  payroll: '/app/hr/payroll',
  ledger: '/app/hr/ledger',
  organization: '/app/hr/organization',
  eJoining: '/e-joining/:token',

  // ── Chat / Communication ──────────────────────────────────────────────
  chat: '/app/chat',
} as const;

export type RouteKey = keyof typeof ROUTES;

/** Build the Edit Proforma route for a document id. */
export const salesProformaEditPath = (id: string) => `/app/sales/proforma/${id}/edit`;
/** Navigation groups for section-based access control (mirrors sidebar structure). */
export const NAV_GROUPS = [
  { group: 'core', label: 'Core', items: [
    { path: '/app/people', label: 'People', access: 'hr' },
    { path: '/app/attendance', label: 'Daily Attendance', access: 'hr' },
    { path: '/app/leaves', label: 'Leaves', access: 'hr' },
  ]},
  { group: 'hiring', label: 'Hiring', items: [
    { path: '/app/hr/recruitment', label: 'Recruitment', access: 'hr' },
    { path: '/app/hr/offer-letters', label: 'Offer Letters', access: 'hr' },
    { path: '/app/hr/onboarding', label: 'Onboarding', access: 'hr' },
  ]},
  { group: 'performance', label: 'Performance', items: [
    { path: '/app/hr/performance', label: 'Performance', access: 'hr' },
    { path: '/app/hr/incentives', label: 'Incentives', access: 'hr' },
  ]},
  { group: 'payroll', label: 'Payroll & Finance', items: [
    { path: '/app/hr/payroll', label: 'Payroll', access: 'payroll' },
    { path: '/app/hr/ledger', label: 'Employee Ledger', access: 'payroll' },
  ]},
  { group: 'operations', label: 'Operations', items: [
    { path: '/app/hr/organization', label: 'Organization', access: 'hr' },
  ]},
  { group: 'communication', label: 'Communication', items: [
    { path: '/app/chat', label: 'ZYNX Chat', access: 'communication' },
  ]},
  { group: 'productivity', label: 'Productivity', items: [
    { path: '/app/notepad', label: 'Notepad', access: 'notes' },
  ]},
] as const;
